/** Arabic is the source language and the default; English is the translation. */
export type Locale = 'ar' | 'en';

export const LOCALES: readonly Locale[] = ['ar', 'en'];
export const DEFAULT_LOCALE: Locale = 'ar';

export type Dir = 'rtl' | 'ltr';

export function dirOf(locale: Locale): Dir {
  return locale === 'ar' ? 'rtl' : 'ltr';
}

export function isLocale(v: unknown): v is Locale {
  return v === 'ar' || v === 'en';
}

/** Picks a locale from an Accept-Language header value; Arabic unless English is preferred. */
export function localeFromAcceptLanguage(header: string | null | undefined): Locale {
  if (!header) return DEFAULT_LOCALE;
  const ranked = header
    .split(',')
    .map((part) => {
      const [tag = '', ...params] = part.trim().split(';');
      const q = params.map((p) => p.trim()).find((p) => p.startsWith('q='));
      return { tag: tag.toLowerCase(), q: q ? Number(q.slice(2)) : 1 };
    })
    .filter((x) => x.tag && !Number.isNaN(x.q))
    .sort((a, b) => b.q - a.q);
  for (const { tag } of ranked) {
    if (tag.startsWith('ar')) return 'ar';
    if (tag.startsWith('en')) return 'en';
  }
  return DEFAULT_LOCALE;
}
